import React, { useState } from 'react';
import {
  Row, Col, Form, Label, Input, Card, CardBody,
  Container, Button, FormFeedback, InputGroup
} from "reactstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "./CustomCheckbox.css";

const VehiclesCategoriesCreate = () => {
  const [type_name, setTypeName] = useState('');
  const [display_name, setDisplayName] = useState('');
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [commissionCharges, setcommissionCharges] = useState('');

  const [validation, setValidation] = useState({
    type_name: null,
    display_name: null,
  });

  const [checkboxes, setCheckboxes] = useState({
    is_active: false,
  });

  const handleCheckboxChange = (key) => {
    setCheckboxes((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const validateFields = () => {
    let isValid = true;
    const newValidation = {
      type_name: type_name.trim() !== '',
      display_name: display_name.trim() !== '',
      commissionCharges: Number(commissionCharges) >= 0.01 && Number(commissionCharges) <= 100,
    };

    setValidation(newValidation);

    Object.values(newValidation).forEach(v => {
      if (!v) isValid = false;
    });

    return isValid;
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("type_name", type_name);
    formData.append("display_name", display_name);
    formData.append("is_active", checkboxes.is_active);
    if (image) formData.append("image", image);

    formData.append("commission_charges", commissionCharges);

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${process.env.REACT_APP_WEB_APP_URL}/api/web/vehicles-categories/create`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (response.status === 200) {
        toast.success('Vehicle category created successfully', { autoClose: 3000 });
        navigate(`/vehicles-categories`);
      } else if (response.status === 422) {
        if (data?.errors) {
          Object.values(data.errors).forEach((errorArr) => {
            errorArr.forEach((errMsg) => toast.error(errMsg, { autoClose: 3000 }));
          });
        } else {
          toast.error(data?.message || 'Validation failed', { autoClose: 3000 });
        }
      } else {
        toast.error(data?.message || `Error: ${response.statusText}`, { autoClose: 3000 });
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to create vehicle category", { autoClose: 3000 });
    } finally {
      setLoading(false);
    }
  };

  document.title = "Add Vehicle Category | Moeen";

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Home" breadcrumbItem="Add Vehicle Category" />

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit}>

                  {/* Type Name + Display Name */}
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label>Type Name</Label>
                        <Input
                          type="text"
                          placeholder="Enter type name"
                          value={type_name}
                          onChange={e => setTypeName(e.target.value)}
                          valid={validation.type_name === true}
                          invalid={validation.type_name === false}
                        />
                        <FormFeedback tooltip>Type name is required.</FormFeedback>
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3">
                        <Label>Display Name</Label>
                        <Input
                          type="text"
                          placeholder="Enter display name"
                          value={display_name}
                          onChange={e => setDisplayName(e.target.value)}
                          valid={validation.display_name === true}
                          invalid={validation.display_name === false}
                        />
                        <FormFeedback tooltip>Display name is required.</FormFeedback>
                      </div>
                    </Col>
                  </Row>

                  {/* Image + Flags */}
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label>Upload Image</Label>
                        <Input
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                        {previewUrl && (
                          <div className="mt-2">
                            <img
                              src={previewUrl}
                              alt="Preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover"
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3">
                        <Label>Additional Flags</Label>
                        <div className="d-flex flex-wrap gap-3">
                          {[{ label: "Is Enabled", key: "is_active" },
                          ].map(({ label, key }) => (
                            <div
                              key={key}
                              className={`custom-box-checkbox ${checkboxes[key] ? "active" : ""}`}
                              onClick={() => handleCheckboxChange(key)}
                            >
                              {label}
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="4">
                      <div className="mb-3">
                        <Label>Commission Charges %</Label>
                        <Input
                          type="number"
                          placeholder="Enter commission charges"
                          value={commissionCharges}
                          onChange={e => setcommissionCharges(e.target.value)}
                          min="0"
                          step="0.01"
                          valid={validation.commissionCharges === true}
                          invalid={validation.commissionCharges === false}
                        />
                        <FormFeedback tooltip>Commission Charges must be between 0.01% and 100%</FormFeedback>
                      </div>
                    </Col>
                  </Row>

                  {/* Submit */}
                  <Row className="mt-4">
                    <Col className="text-end">
                      <Button type="submit" color="primary" disabled={loading}>
                        {loading ? (
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </Col>
                  </Row>

                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VehiclesCategoriesCreate;
